import assertContainerElement from "Utils/assertContainerElement";
import React from "react";
import { render } from "react-dom";
import { Badge } from ".";


export function init(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>, onClaim: () => void) {
   const bannerContainer = document.getElementById("cyp-badge-container");
   assertContainerElement(bannerContainer);

   render(<Badge isClaimable={model.IsClaimable} onClaim={onClaim} />, bannerContainer);
}
